<template>
  <div class="p-develop">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>发展历程</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box">
      <div class="time">
        <div class="swiper-container" id="swiper1">
          <div class="num swiper-wrapper">
            <div
              class="num_years swiper-slide"
              v-for="(item, index) of list"
              :key="index"
            >
              <div class="num_year">
                {{ item.title.slice(0, 4) }}
              </div>
              <div class="dian"></div>
            </div>
          </div>
        </div>

        <div class="time_lines">
          <div class="left_icon swiper-button-prev">
            <img src="@/assets/img/icon/iconrightb.png" />
          </div>
          <div class="time_line"></div>
          <div class="right_icon swiper-button-next">
            <img src="@/assets/img/icon/iconrightb.png" />
          </div>
        </div>
      </div>
      <div class="nav swiper-container" id="swiper2">
        <div class="swiper-wrapper">
          <div
            class="box swiper-slide"
            v-for="(item, index) of list"
            :key="index"
          >
            <div
              class="left_img"
              :style="{ backgroundImage: 'url(' + item.image + ')' }"
            ></div>
            <div class="content">
              <img src="@/assets/img/about/develop/icon1.png" />
              <p class="text_time">{{ item.title }}</p>
              <div class="sm_line"></div>
              <p class="text_text">{{ item.tips }}</p>
              <img
                class="icon_right"
                src="@/assets/img/about/develop/icon2.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
import Swiper from "swiper/swiper-bundle";
export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    init() {
      this.params = this.$route.params;
      this.getAjax();
    },
    async getAjax() {
      await this.getList();
      this.$nextTick(() => {
        this.UserSwiper();
      });
    },
    UserSwiper() {
      var thumbsSwiper = new Swiper("#swiper1", {
        loop: false,
        slidesPerView: 7,
        watchSlidesVisibility: true, //防止不可点击
      });
      new Swiper("#swiper2", {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        disabledClass: "my-button-disabled",
        thumbs: {
          swiper: thumbsSwiper,
          slideThumbActiveClass: "my-slide-thumb-active",
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 80px;
  width: 100%;
  height: 280px;
  background: url(~@/assets/img/about/develop/title.png) no-repeat center;
  background-size: cover;
}
.title_text {
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  text-align-last: justify;
  text-align: justify;
  line-height: 84px;
  letter-spacing: 20px;
}
.time {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 100px;
  .num {
    display: flex;
    justify-content: space-between;
    width: 900px;
    .num_years {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      height: 92px;
      cursor: pointer;
      .num_year {
        height: 30px;
        font-size: 22px;
        font-weight: 400;
        color: #656878;
        line-height: 30px;
        margin-bottom: 10px;
      }
      .dian {
        width: 20px;
        height: 20px;
        background: #0030aa;
        border: 6px solid #ffffff;
        border-radius: 20px;
        z-index: 1;
      }
    }
  }
  .time_lines {
    width: 1100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -28px;
    margin-bottom: -30px;
    .time_line {
      width: 1000px;
      height: 6px;
      background-color: #0030aa;
    }
    .left_icon,
    .right_icon {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .left_icon {
      transform: rotate(180deg);
    }
  }
}
.nav {
  .box {
    display: flex;
    margin-bottom: 120px;
    .content {
      margin-left: 60px;
      .text_time {
        height: 50px;
        font-size: 36px;
        font-weight: 500;
        color: #000000;
        line-height: 50px;
        margin-left: 120px;
        margin-top: -32px;
      }
      .sm_line {
        width: 60px;
        height: 2px;
        background: #0030aa;
        margin-left: 120px;
        margin-top: 20px;
      }
      .text_text {
        width: 265px;
        height: 25px;
        font-size: 18px;
        font-weight: 400;
        color: #000000;
        line-height: 25px;
        margin-left: 120px;
        margin-top: 60px;
      }
      .icon_right {
        margin-left: 480px;
        margin-top: 35px;
      }
    }
  }
}
.left_img {
  width: 420px;
  height: 320px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.my-slide-thumb-active ::v-deep {
  .num_year {
    height: 50px !important;
    font-size: 36px !important;
    font-weight: 600 !important;
    color: #0030aa !important;
    line-height: 50px !important;
  }
  .dian {
    width: 20px !important;
    height: 20px !important;
    background: #ffffff !important;
    border: 6px solid #0030aa !important;
  }
}
</style>
